import { permissionsByEntity, useCheckAccountType, useCheckPermissions } from '@cmg/auth';
import React from 'react';

import { useGetOfferingEntitlementsQuery } from '../check-entitlements/useGetOfferingEntitlementsQuery';

type Props = {
  offeringId?: string;
};

type AccessCheckResult = {
  loading: boolean;
  canRead: boolean;
  canUpdate: boolean;
  isSellSideAccount: boolean;
};

/**
 * Checks accessibility of an My Retail.
 */
export function useCheckMyRetailAccess({ offeringId }: Props): AccessCheckResult {
  const hasRead = useCheckPermissions([permissionsByEntity.RetailDemand.READ]);
  const hasFull = useCheckPermissions([permissionsByEntity.RetailDemand.FULL]);

  const { data: entitlements, loading } = useGetOfferingEntitlementsQuery({ offeringId });
  const isSellSideAccount = useCheckAccountType('SELL_SIDE');
  const accessChecks = React.useMemo(
    () => ({
      canRead: hasRead && isSellSideAccount && entitlements.includes('MANAGE:MY_RETAIL'),
      canUpdate: hasFull && isSellSideAccount && entitlements.includes('MANAGE:MY_RETAIL'),
    }),
    [hasRead, hasFull, entitlements, isSellSideAccount]
  );

  return { loading, ...accessChecks, isSellSideAccount };
}
